module.exports = __webpack_public_path__ + "static/media/Trumpet.c8c16a95.webp";